module.exports = __webpack_public_path__ + "static/media/distrSpotify.1baa12d4.png";